import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const LotSaleOrderUpdateDialogTourConfig: AgTechTourConfig = {
    id: 'lot-sale-order-update-dialog-tour',
    name: 'Change Sale Order Tour',
    steps: [
        {
            targetId: 'lot-sale-order-instructions',
            title: 'Reordering Lots',
            description: 'Change the order lots will sell in. Enter a new sale order for each lot you want to move, then submit to save all changes at once.',
            position: 'bottom',
        },
        {
            targetId: 'lot-sale-order-grid',
            title: 'Sale Order Grid',
            description: 'Type a new number in New Sale Order. If another lot already uses that number it is cleared and highlighted so you can give it a new one. Old Sale Order is shown for reference. Every lot needs a valid order before you submit.',
            position: 'top',
        },
    ]
}
